// Module
var code = "<a class=\"btn btn-purple\"> <icon-upload></icon-upload> Upload document </a> ";
// Exports
module.exports = code;